module.exports = __webpack_public_path__ + "img/RegisterOfDocuments.8ab3f624.svg";